import { connectHits } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'
import trainingSearch from './trainingSearch'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  if (hits.length !== 0) {
    widgetParams.container.innerHTML =
      '<ul class="flex flex-wrap"></ul>'

    hits.forEach((hit) => {
      // create li element, add classes
      const li = document.createElement('li')
      li.classList.add('flex')
      li.classList.add('training-card-inner')

      li.innerHTML = `
        <div class="training-card flex flex-col justify-between">
          <div>
            <p class="tracking-tight text-dark-blue font-medium mb-3">Réf : ${hit.ref}</p>
            <p class="title-4 title-4--dark-blue mb-6">${hit.name}</p>
            <p class="leading-big"> 
              ${hit.goals.map((goal) => `${goal}.`).join(' ')}
            </p>
          </div>
          <a href="/${hit.path}" class="button mt-6">
            Voir la formation
            <svg width="16" height="16">
              <use href="#icon-triangle" xlink:href="#icon-triangle"></use>
            </svg>
          </a>
        </div>
      `

      get('ul', widgetParams.container).appendChild(li)

      get('a', li).addEventListener('click', () => {
        trainingSearch.saveFilters(renderOptions.instantSearchInstance)
      })
    })
  }
}

const customHitsInner = connectHits(renderHits)

export default customHitsInner
